import MicroModal from 'micromodal';
import $ from 'jquery';

(function (Modal) {
  App.registerBehavior('Modal', function registerModalBehavior() {
    $('[data-modal]').once('ModalBehavior').each(function () {
      MicroModal.init();
      // The triggering HTML element
      const $trigger = $(this);
      $trigger.on('click', function (e) {
        const action = 'string' === typeof $trigger.data('modal') && $trigger.data('modal') || 'open';
        const id = 'string' === typeof $trigger.data('modal-id') && $trigger.data('modal-id') || 'modal-default';
        const isConfirmationDialog = 'modal-confirm' === id || 'modal-confirm-critical' === id;
        const confirmationMessage = isConfirmationDialog && 'string' === typeof $trigger.data('modal-confirmation') && $trigger.data('modal-confirmation') || '';
        // Confirmation button
        const confirmationButtonLabel = isConfirmationDialog && 'string' === typeof $trigger.data('modal-confirm-label') && $trigger.data('modal-confirm-label') || '';
        const confirmationAction = isConfirmationDialog && $trigger.attr('href') || '';
        const $modal = $('#' + id);
        const modalTitle = $trigger.data('modal-title') || '';
        let modal;
        e.preventDefault();
        if ('open' === action
          && 0 < $modal.length) {
          // Populate the modal
          modal = new Modal($modal);
          // Avoid override with empty title
          if (modalTitle) {
            modal.setTitle(modalTitle);
          }
          if (confirmationMessage) {
            modal.setContent(confirmationMessage)
          }
          if (confirmationButtonLabel) {
            modal.setConfirmationButtonLabel(confirmationButtonLabel);
          }
          if (confirmationAction) {
            modal.setConfirmationAction(confirmationAction);
          }
          // Finally, open the modal
          modal.open();
        }
      });
    });
  });
})(App.modal);